import { GraphSchema } from '@camelot/server';
import { MissionType } from '@camelot/services';

export interface Missionview {
  id: string;
  tenantId: string;
  title: string;
  lat: number;
  lng: number;
  start: string;
  end: string;
  type: MissionType;
  contactId: string;
  contactFullName: string;
  projectId: string;
  projectName: string;
  projectAddress: string;
  departmentId: string;
  departmentName: string;
  createdById: string;
  createdByFullName: string;
  createdTime: string;
  updatedById: string;
  updatedByFullName: string;
  updatedTime: string;
}
export const missionViewProps = new GraphSchema<Missionview>([
  'id',
  'title',
  'type',
  'contactFullName',
  'projectAddress',
  'contactId',
  'departmentName',
  'projectId',
]);
